 <p-blockUI [blocked]="blockedDocument">
 <div class="fixed inset-0 flex flex-col items-center justify-center bg-gray-900/50 z-50">
        <p-progressSpinner></p-progressSpinner>
        <span class="text-white text-lg mt-4">Loading...</span>
 </div>       
</p-blockUI>
 <p-dialog header="Add new user" [modal]="true" [(visible)]="visible" [style]="{ width: '70w' }" 
            (onShow)="loadData()" (onHide)="close()">
            <p-toast />
        <app-input-text [form]="userForm" field="username" label="Username" placeholder="Username"></app-input-text>
        <app-input-text [form]="userForm" field="email" label="Email" placeholder="Email"></app-input-text>
        <app-multi-select-input [options]="roles" field="roles" placeholder="Select System Roles" label="System Role" [form]="userForm" />
        @if(isSysAdmin) {
        <app-input-select [options]="accountOptions" field="accountID" label="Account" placeholder="Select Account" [form]="userForm"></app-input-select>

        }
        <app-input-select [options]="statusOptions" field="active" label="Active" placeholder="Status" [form]="userForm"></app-input-select>
        <app-input-select [options]="organizationOptions" field="organizationID" label="Organization" placeholder="Organization" [form]="userForm"></app-input-select>
        <app-input-text [form]="userForm" field="organizationTitle" label="Title" placeholder="Title"></app-input-text>
 
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" (click)="close()" />
            <p-button label="Save" (click)="save();" />
        </div>
    </p-dialog>